export const GET_EVENTS_DATA = "GET_EVENTS_DATA";
export const SET_LOADING_EVENTS_DATA = "SET_LOADING_EVENTS_DATA";
export const GET_EVENT_DETAILS_DATA = "GET_EVENT_DETAILS_DATA";
export const SET_EVENT_DETAILS_DATA_LOADING = "SET_EVENT_DETAILS_DATA_LOADING"
export const SET_EVENT_LOGS_DOWNLOAD_CSV_LOADING = "SET_EVENT_LOGS_DOWNLOAD_CSV_LOADING"
